// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__29AIf","title":"ClientReferral_title__28qUM","itemText":"ClientReferral_itemText__2ksLv"};